import styled from 'styled-components';
import { EditorContent } from '@tiptap/react';

import { rem } from 'approot/shared/style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { grey6 } from 'approot/shared/styles/colours.style';
import {
  FillInBlanksFieldCss,
  FillInBlanksFontSizeCss,
  FillInBlanksFontSizeProps,
  FillInBlanksLabelSupport,
  FillInBlanksPunctuationCss,
} from './fill-in-blanks-shared.style';
import { FontFamily, FontSize } from './use-fill-in-blanks-font-sizes';

type FillInBlanksFieldProps = {
  $colours: ColourItem;
  $minWidth: number;
  $punctuation: string | null;
  $hasLabel: boolean;
  $hasTextOverflowed: boolean;
  $fontSize: FontSize | null;
  $fontFamily: FontFamily;
};

export const FillInBlanksField = styled.div<FillInBlanksFieldProps>`
  display: inline-flex;

  ${({ $hasTextOverflowed, $minWidth = 100 }) =>
    $hasTextOverflowed
      ? `
      min-width: ${rem($minWidth)};
  `
      : `
    max-width: ${rem($minWidth)};
    width: 100%;
  `};

  ${({ $colours }) =>
    $colours &&
    `
    &:focus-within {
      box-shadow: inset 0px 0px 0 2px ${$colours.base};
      border-bottom-color: transparent;
    }
  `}

  ${FillInBlanksFontSizeCss}
  ${FillInBlanksFieldCss}
  ${FillInBlanksPunctuationCss}
`;

type FillInBlanksAnswerProps = {
  $colours: ColourItem;
  $placeholder?: string | null;
  $label: string | null;
} & FillInBlanksFontSizeProps;
export const FillInBlanksAnswer = styled(
  EditorContent
)<FillInBlanksAnswerProps>`
  padding: 0;
  position: relative;
  width: 100%;

  .tiptap {
    ${FillInBlanksFontSizeCss}
    outline: none;
    width: 100%;

    p {
      margin-bottom: 0;
    }

    .is-empty:first-child {
      overflow: hidden;
    }

    .is-empty:first-child::before {
      color: ${grey6};
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
      white-space: nowrap;
    }
  }

  ${FillInBlanksLabelSupport}
`;
